import { titleCase } from "title-case";
import { match } from "ts-pattern";
import { TagIntent, type TagProps } from "widgets";

import { JobStatusEnum } from "@/graphql.ts";

export function matchStatusToTagIntent(status: JobStatusEnum | null | undefined) {
  return match<JobStatusEnum | null | undefined, Pick<TagProps, "label" | "intentColor">>(status)
    .with(JobStatusEnum.Initializing, () => ({
      label: titleCase(JobStatusEnum.Initializing),
      intentColor: TagIntent.Secondary,
    }))
    .with(JobStatusEnum.Queued, () => ({ label: titleCase(JobStatusEnum.Queued), intentColor: TagIntent.Primary }))
    .with(JobStatusEnum.Completed, () => ({
      label: titleCase(JobStatusEnum.Completed),
      intentColor: TagIntent.Success,
    }))
    .with(JobStatusEnum.Error, () => ({ label: titleCase(JobStatusEnum.Error), intentColor: TagIntent.Danger }))
    .with(JobStatusEnum.Terminated, () => ({
      label: titleCase(JobStatusEnum.Terminated),
      intentColor: TagIntent.Danger,
    }))
    .with(JobStatusEnum.Running, () => ({
      label: titleCase(JobStatusEnum.Running),
      intentColor: TagIntent.Warning,
    }))
    .otherwise(() => ({ label: status }));
}

export function isErrorJobStatus(status?: JobStatusEnum | null) {
  return status && (status === JobStatusEnum.Error || status === JobStatusEnum.Terminated);
}
